import * as React from 'react';
export const IcThunderstormLight = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 15.67c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-4 0c-.48-.28-1.09-.11-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zM18.5 8c.33 0 .65.06.96.16.02-.14.04-.27.04-.41C19.5 5.13 17.37 3 14.75 3c-1.64 0-3.08.83-3.93 2.09A3.68 3.68 0 0010 5a3.98 3.98 0 00-3.86 3.01C6.09 8.01 6.05 8 6 8c-1.66 0-3 1.34-3 3s1.34 3 3 3h6.92c.03-.05.05-.11.08-.17l3-4.5c.56-.84 1.49-1.34 2.5-1.34V8zm1.36 6.99a.99.99 0 00-.86-.49h-1.63l1.96-2.95a1.001 1.001 0 10-1.67-1.11l-3 4.5c-.2.31-.22.7-.05 1.03.17.33.51.53.88.53h1.8l-1.67 3.01c-.27.48-.09 1.09.39 1.36.15.09.32.13.48.13.35 0 .69-.19.88-.51l2.5-4.5c.17-.31.17-.69-.01-.99v-.01z'
      fill='currentColor'
    />
  </svg>
);
